import HttpClient from './HttpClient';
import { useMutation, useQuery } from '@tanstack/react-query';

const httpClient = new HttpClient();

interface UploadProfileImageData {
  fileExtension: string;
  contentType: string;
}

interface UpdateProfileImageData {
  s3Key: string;
}

interface ProfileImageResponse {
  profileImageUrl: string | null;
}

interface UploadUrlResponse {
  uploadUrl: string;
  s3Key: string;
  message: string;
}

interface UpdateProfileImageResponse {
  profileImageUrl: string;
  message: string;
}

// Generate presigned upload URL
export const generateUploadUrl = async (data: UploadProfileImageData): Promise<UploadUrlResponse> => {
  const response = await httpClient.get('api/profile/upload-url', data);
  return response.data;
};

export const useGenerateUploadUrl = () => {
  return useMutation({
    mutationFn: generateUploadUrl,
  });
};

// Update profile image with S3 key
export const updateProfileImage = async (data: UpdateProfileImageData): Promise<UpdateProfileImageResponse> => {
  const response = await httpClient.post('api/profile/update', data);
  return response.data;
};

export const useUpdateProfileImage = () => {
  return useMutation({
    mutationFn: updateProfileImage,
  });
};

// Get current profile image
export const getProfileImage = async (): Promise<ProfileImageResponse> => {
  const response = await httpClient.get('api/profile/image', {});
  return response.data;
};

export const useProfileImage = (options?: { enabled?: boolean }) => {
  return useQuery<ProfileImageResponse, Error>({
    queryKey: ['profileImage'],
    queryFn: getProfileImage,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: options?.enabled ?? true,
  });
};

// Delete profile image
export const deleteProfileImage = async (): Promise<{ message: string }> => {
  const response = await httpClient.delete('api/profile/image');
  return response.data;
};

export const useDeleteProfileImage = () => {
  return useMutation({
    mutationFn: deleteProfileImage,
  });
};

